import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TCorePage } from "../../Types";
import { post } from "../axios-post";

export const apiCallRemoveSilentBan = async ({
  userUUID,
  pageName
}: {
  userUUID: string;
  pageName: TCorePage;
}): Promise<{
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post(`user/removeSilentBan`, {
    userUUID,
    pageName
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      status: "ERROR",
      code: "ERROR"
    };
  }
};
